export default __webpack_public_path__ + "static/media/Referralpic.fdfaa415.png";